import Vue from 'vue';

/**
 * Services
 */
import DI from 'myra-ui-common/services/DI';
import './services/I18n';
import 'myra-ui-common/services/EventBus';
import 'myra-ui-common/services/ApiRouter';
import 'myra-ui-common/services/Cookie';
import 'myra-ui-common/services/JWTStorage';
import 'myra-ui-common/services/ApiClient';
import 'myra-ui-common/services/LocalStorage';

/**
 * CSS libraries
 */
import 'primeflex/primeflex.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';

/**
 * Vue plugins
 */
import DIPlugin from 'myra-ui-common/plugins/DIPlugin';
import EventBusPlugin from 'myra-ui-common/plugins/EventBusPlugin';
import ApiClientPlugin from 'myra-ui-common/plugins/ApiClientPlugin';
import ToastService from 'primevue/toastservice';
import NotifierPlugin from 'myra-ui-common/plugins/NotifierPlugin';
import LocalStoragePlugin from 'myra-ui-common/plugins/LocalStoragePlugin';

Vue.use(DIPlugin);
Vue.use(EventBusPlugin);
Vue.use(ApiClientPlugin);
Vue.use(ToastService);
Vue.use(NotifierPlugin);
Vue.use(LocalStoragePlugin);

/**
 * Initialize
 */
import App from './App.vue';
import router from './router';
import store from './store/store';

new Vue({
    i18n   : DI.container.i18n,
    router,
    store,
    render : (h) => h(App),
}).$mount('#app');
